export default __webpack_public_path__ + "static/media/car.b28e55ec.svg";